import { render, staticRenderFns } from "./AdminActionsTable.vue?vue&type=template&id=325fd890&"
import script from "./AdminActionsTable.vue?vue&type=script&lang=js&"
export * from "./AdminActionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports